import { IInvoiceLineItem } from "@wingspanhq/payments/dist/interfaces";
import isEmpty from "lodash/isEmpty";
import { calculateLineItemRegularPrice } from "../../../Invoices/utils";
import { IInvoiceRow } from "../service";
import { selectorInvoiceRowClientName } from "../selectors/selectorInvoiceRowClientName";
import { toWSDateString } from "@wingspanhq/fe-component-library";

const lineItemFieldToCSVString = (
  map: (a: IInvoiceLineItem, index: number) => any,
  lineItems: IInvoiceLineItem[]
) => {
  if (isEmpty(lineItems)) {
    return undefined;
  }

  const mappedArray = lineItems
    .map(map)
    .filter(l => l !== undefined && l !== "" && l !== null);

  return mappedArray.length ? mappedArray.join(", ") : undefined;
};

export const mapInvoiceToCsvTable = (invoice: IInvoiceRow) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return {
    "Invoice ID": invoice.invoiceId,
    "Parent Invoice ID": invoice.parentInvoiceId,
    "Member Client ID": invoice.memberClientId,
    "Purchase Order Number": invoice.purchaseOrderNumber,
    "Client Name": selectorInvoiceRowClientName(invoice).primaryName,
    "Client Email": invoice.clientEmail,
    "Member Gross Amount": invoice.amountDetails?.memberGross,
    "Member Net Amount": invoice.amountDetails?.memberNet,
    Currency: invoice.currency?.toUpperCase(),
    "Tax Withheld": invoice.amountDetails?.memberTaxWithheld,
    "Processing Fee": invoice.amountDetails?.processingFee,
    Amount: invoice.amount,
    "Due Date": invoice.dueDate
      ? toWSDateString(invoice.dueDate, "input")
      : undefined,
    "Check Date": invoice.client?.payDate
      ? toWSDateString(invoice.client.payDate, "input")
      : undefined,
    "Created Date": invoice.createdAt
      ? toWSDateString(invoice.createdAt)
      : undefined,
    "Sent Date": invoice?.events?.sentAt
      ? toWSDateString(invoice.events.sentAt)
      : undefined,
    "Opened Date": invoice?.events?.openedAt
      ? toWSDateString(invoice.events.openedAt)
      : undefined,
    "Member Disputed Date": invoice?.events?.disputedAt
      ? toWSDateString(invoice.events.disputedAt)
      : undefined,
    "Invoice Declined Date": invoice?.events?.clientDeclinedAt
      ? toWSDateString(invoice.events.clientDeclinedAt)
      : undefined,
    // "Pre-Approved Date": TODO
    "Approved Date": invoice?.events?.approvedAt
      ? toWSDateString(invoice.events.approvedAt)
      : undefined,
    "Paid Date": invoice?.events?.paidAt
      ? toWSDateString(invoice.events.paidAt)
      : undefined,
    "Deposited Date": invoice?.events?.depositedAt
      ? toWSDateString(invoice.events.depositedAt)
      : undefined,
    "Estimated Deposit Date": invoice?.events?.estimatedDepositAt
      ? toWSDateString(invoice.events.estimatedDepositAt)
      : undefined,
    "Cancelled Date": invoice?.events?.cancelledAt
      ? toWSDateString(invoice.events.cancelledAt)
      : undefined,
    Timezone: timezone,
    "Invoice Number": invoice.invoiceNumber,
    "Invoice Type": invoice.labels?.invoiceType,
    "Member Workflow Status": invoice.member?.workflowStatus,
    "Client Workflow Status": invoice.client?.workflowStatus,
    Status: invoice.status,
    // "Payroll Invoice Number": TODO
    // "Payroll Invoice Amount": TODO
    "Project Name": invoice.projectName,
    "Invoice PDF": invoice.attachments?.invoicePdf,
    "Receipt PDF": invoice.attachments?.receiptPdf,
    "Invoice Link": invoice.attachments?.invoiceLink,
    "Line Items": isEmpty(invoice.lineItems)
      ? undefined
      : JSON.stringify(invoice.lineItems)
          // fix json string in csv
          .replace(/"/g, '""'),
    "Invoice Notes": invoice.invoiceNotes,
    "Member Comment": invoice.member?.comment,
    "Line Item Index": lineItemFieldToCSVString(
      (l, index) => index,
      invoice.lineItems
    ),
    "Line Item Title": lineItemFieldToCSVString(
      l => l.description,
      invoice.lineItems
    ),
    "Line Item Description": lineItemFieldToCSVString(
      l => l.detail,
      invoice.lineItems
    ),
    "Line Item Amount": lineItemFieldToCSVString(
      l => calculateLineItemRegularPrice(l)?.toFixed(2),
      invoice.lineItems
    )
    //   ...(isEmpty(invoice.labels)
    //     ? {}
    //     : Object.keys(invoice.labels as any)
    //         .filter(key => !["createdBy"].includes(key))
    //         .reduce((acc, key) => {
    //           return {
    //             ...acc,
    //             [`Custom Field ${key}`]: invoice.labels[key]
    //           };
    //         }, {}))
  };
};
